import useWebchatVersion from 'app/hooks/useWebchatVersion';
import { ChatVersion } from 'app/copied/constants/common';

import leftArrowIcon from '../../assets/icons/left-arrow.svg';

export default function LeftArrowIcon({ className }: { className?: string }) {
  const webchatVersion = useWebchatVersion();

  if (webchatVersion === ChatVersion.v4_1) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M12.6663 8H3.33301"
          stroke="#1B1B1B"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.99967 12.6663L3.33301 7.99967L7.99967 3.33301"
          stroke="#1B1B1B"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <img
      src={leftArrowIcon}
      alt="Left Arrow Icon"
      className={className}
    />
  );
}
